import { Scroller } from './animations';
import { Page, LazyLoad } from './shared';
import ModuleLoader from './modules/module.loader.js';
import Nav from './nav/nav.js';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class App extends Page {

	constructor(el) {
		super(el);
		this.init();
		this.initAnimations();
		this.initModules();
		this.exportMethods();
	}

	initAnimations() {
		this.scroller = new Scroller();
		this.navigation = new Nav(this.nav, this.scroller);
		this.isMobile && ScrollTrigger.normalizeScroll(true);
	}

	initModules() {
		this.modules = ModuleLoader.moduleLoader(this.body);
		this.images = new LazyLoad(this.body);
	}

	exportMethods() {
		window.client = {
		  scroller: {
			start: () => this.scroller.start(),
			stop: () => this.scroller.stop(),
			toggle: () => this.scroller.toggle(),
			instance: () => this.scroller
		  },
		}
	  }
}

window.onload = () => {
	const app = new App();
};

